const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { internalSwimlaneExportSearchSchema } from '@/components/views/export/ExportSwimlanePage';

/**
 * Export route for roadmap SVG generation with token authentication.
 *
 * Renders the same static, non-virtualized swimlane layout as the PNG route
 * (the SVG export worker walks the live DOM and emits SVG primitives — it
 * relies on every row being present in the DOM, not just the visible viewport).
 *
 * Authentication: JWT token passed via ?token= query parameter (validated by backend API).
 * URL Pattern: /export/v1/loop-visualization/view/:viewId/visualization/:visualizationId/swimlane/svg?token={jwt}&...
 */
export const Route = createFileRoute('/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg')({
  validateSearch: zodValidator(internalSwimlaneExportSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});